"use client";

import { ReactNode, memo } from "react";
import { createPortal } from "react-dom";

interface PortalProps {
  children: ReactNode;
  containerId?: string;
}

const PortalClient = ({ children, containerId = "portal-root" }: PortalProps) => {
  if (typeof window === "undefined") return null;

  const container = document.getElementById(containerId);
  if (!container) return null;

  return createPortal(children, container);
};

export default memo(PortalClient);
